/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getAllAppointmentList = async (
  token,
  type = null,
  page = null,
  per_page = null,
  sort_column,
  sort_order,
  filter
) => {
  let endpoint =
    type === null
      ? `/api/v1/admin/appointments?page=${page}&per_page=${per_page}`
      : `/api/v1/admin/appointments?type=${type}`;
  if (sort_column && sort_order) {
    endpoint += `&sort_column=${sort_column}&sort_order=${sort_order}`;
  }
  if (filter) {
    Object.entries(filter).forEach(([key, value]) => {
      if (value !== null && value !== "") {
        endpoint += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      }
    });
  }
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
